// extracted by mini-css-extract-plugin
export var innerStyle = "toc_nav_desktop-module--innerStyle--sEyhx";
export var isActiveStyle = "toc_nav_desktop-module--isActiveStyle--qjEmn";
export var wrapperStyle = "toc_nav_desktop-module--wrapperStyle--yVbVz";